
export default {
  install(Vue) {
    Vue.prototype.$clientLogoUrl = (client = null) => {
      try {
        if (client.logoUrl.startsWith(`/`)) {
          return require(`@/assets/slug/${client.slug}.png`); // eslint-disable-line
        }
        return client.logoUrl;
      } catch (e) {
        return null;
      }
    };
  },
};
